<template>
  <footer class="app-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-2 col-xl-3 footer-logo">
          <a href="https://precisionhealthreports.com/" target="_blank">
            <svg-icon name="logo-grayscale" />
          </a>
        </div>
        <div class="col-12 col-md-7 col-lg-6 col-xl-6 footer-links">
          <div class="footer-links-content">
            <ul class="menu-links">
              <li>
                <a href="https://precisionhealthreports.com/services" target="_blank">Services</a>
              </li>
              <li>
                <a href="https://precisionhealthreports.com/about" target="_blank">About Us</a>
              </li>
              <li>
                <a href="https://precisionhealthreports.com/blog" target="_blank">Blog</a>
              </li>
              <li>
                <a href="https://precisionhealthreports.com/contact-us" target="_blank">Contact</a>
              </li>
              <li>
                  <a href="https://precisionhealthreports.com/disclaimer" target="_blank">Disclaimer</a>
              </li>
            </ul>
            <ul class="social-links">
              <li>
                <a href="https://www.linkedin.com/company/precisionhealthreports/" target="_blank">
                  <svg-icon name="linkedin" />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/PreciseHlthRpt" target="_blank">
                  <svg-icon name="twitter" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-5 col-lg-4 col-xl-3 footer-copyright">
          <div class="footer-copyright-seal">
            <span id="siteseal" />
          </div>
          <div class="footer-copyright-content">
            <div class="copyright">
              &copy; Precision Health Reports, {{currentYear}}
            </div>
            <div class="privacy">
              <a href="https://precisionhealthreports.com/privacy" target="_blank">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {
        currentYear: (new Date()).getFullYear()
      }
    },

    mounted() {
      let goDaddy = document.createElement('script');
      goDaddy.setAttribute('src', 'https://seal.godaddy.com/getSeal?sealID=WBA5oljUiKOUEM94ex8XH911Ta8aqWCKvu8URD6URGGrE2bGcPN7ZGeauJJP');
      document.head.appendChild(goDaddy);
    }
  };
</script>